module.exports = __webpack_public_path__ + "static/img/login.377d55e1.png";